<template>
	<div class="drawer">
		<el-drawer
		v-if="curItem.memberId"
		size="600px"
		title="添加回访"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row class="row">
					<el-col :span="24">
						<span class="label">姓名：</span>
						<span class="value">
							{{curItem.memberName}}
						</span>
					</el-col>
				</el-row>
				<!-- <el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">性别：</span>
						<span class="value">
							{{userInfo.basic_info.sex}}
						</span>
					</el-col>
				</el-row> -->
				<el-row class="row">
					<el-col :span="24">
						<span class="label">手机号：</span>
						<span class="value">
							{{curItem.memberMobile}}
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
						<span class="label">回访时间：</span>
						<span class="value">
							{{$public.FTime(curItem.nextVisitTimeValue)}}
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
						<span class="label">回访结果：</span>
						<span class="value" style="vertical-align: top;">
							<el-select style="width:380px;" size="mini" class="select" v-model="visitResultId" placeholder="请选择回访结果">
								<el-option v-for="item in resultList" :key="item.item_id"
								:label="item.item_name" :value="item.item_id">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
						<span class="label">回访记录：</span>
						<span class="value" style="vertical-align: top;">
							<el-input style="width:380px;" type="textarea" :rows="5" v-model="replyContent" placeholder="请填写回访内容"></el-input>
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
						<span class="label">是否再次回访：</span>
						<span class="value" style="vertical-align: top;">
							<el-radio-group v-model="needReply" size="mini">
								<el-radio :label="true">是</el-radio>
								<el-radio :label="false">否</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row v-if="needReply" class="row">
					<el-col :span="24">
						<span class="label">下次回访时间：</span>
						<span class="value">
							<el-date-picker style="width:380px;" v-model="nextReplyTime" size="mini" :picker-options="{disabledDate(time) {return new Date().getTime() > time.getTime()}}" type="date" placeholder="选择下次回访时间">
							</el-date-picker>
						</span>
					</el-col>
				</el-row>
				<el-row v-if="!needReply" class="row">
					<el-col :span="24">
						<span class="label">原因：</span>
						<span class="value">
							<el-select style="width:380px;" size="mini" class="select" v-model="cause" placeholder="请选择原因">
								<el-option v-for="item in [
									{value:'停机换号',label:'停机换号'},
									{value:'搬家距离远',label:'搬家距离远'},
									{value:'体验不好',label:'体验不好'},
									{value:'不想来了',label:'不想来了'},
									{value:'宠物死亡',label:'宠物死亡'},
									{value:'其他',label:'其他'},
								]" :key="item.value"
								:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row v-if="cause==='其他'" class="row">
					<el-col :span="24">
						<span class="label">其他原因：</span>
						<span class="value" style="vertical-align: top;">
							<el-input style="width:380px;" type="textarea" :rows="3" v-model="otherCause" placeholder="请填写其他原因"></el-input>
						</span>
					</el-col>
				</el-row>
				<div style="height: 40px;width:100%;"></div>
				<div class="btnBox">
					<div class="btnItem" @click="handleClose">取消</div>
					<div class="btnItem submit" @click="submit_check">确定</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				needReply:true,
				cause:'',
				otherCause:'',
				replyContent:'',
				nextReplyTime:'',
				
				visitResultId:'',
				resultList:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.$http.get(process.env.VUE_APP_zichan+'/api/SystemConfig/GetSystemDictionByCode', {code:'visitresult'}).then(res=>{
				if(res.code===0){
					this.resultList = res.data.item_list;
				}
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submit_check(){
				if(this.visitResultId===''){
					this.$message({
						message: '请选择回访结果',
						type: 'error'
					});
					return ;
				}
				if(this.replyContent==''){
					this.$message({
						message: '请填写回访内容',
						type: 'error'
					});
					return ;
				}
				if(this.needReply){
					this.cause = ''
					this.otherCause = ''
					if(this.nextReplyTime===''){
						this.$message({
							message: '请选择下次回访时间',
							type: 'error'
						});
						return ;
					}
				}else{
					this.nextReplyTime = ''
					if(this.cause===''){
						this.$message({
							message: '请选择不再回访原因',
							type: 'error'
						});
						return ;
					}
					if(this.cause==='其他'){
						if(this.otherCause===''){
							this.$message({
								message: '请填写其他原因',
								type: 'error'
							});
							return ;
						}
					}
				}
				let params = {
					"memberId": this.curItem.memberId,
					"memberName": this.curItem.memberName,
					"memberMobile": this.curItem.memberMobile,
					"visitResultId": this.visitResultId,
					"visitResultName": this.$public.getMatchingItem(this.resultList,'item_id',this.visitResultId).item_name,
					"needReply": this.needReply,
					"cause": this.cause==='其他'?this.otherCause:this.cause,
					"replyContent": this.replyContent,
					"nextReplyTime": this.nextReplyTime?new Date(this.nextReplyTime).getTime().toString().substr(0,10):'',
				}
				console.log(params)
				this.$http.post('/api/Platform/InsertReply', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit('submit',{type:'success'})
					}
				})
				// let params = {
				// 	"visitResult": {
				// 		"id": "string",
				// 		"name": "string",
				// 	},
				// 	"visitContent": "string",
				// 	"returnVisitType": 0,
				// 	"otherParam": "string",
				// 	"memberInfo": {
				// 		"memberId": "string",
				// 		"memberName": "string",
				// 		"memberMobile": "string",
				// 		"remark": "string",
				// 	},
				// 	"openInvitation": false, // 是否邀约
				// 	"addInvitationInfo": { // 邀约信息
				// 		// "invitationStaffInfo": {
				// 		// 	"userId": "string",
				// 		// 	"userName": "string"
				// 		// },
				// 		// "invitationType": 0,
				// 		// "invitationRemark": "string",
				// 		// "synergyInfo": {
				// 		// 	"synergyStaffInfo": {
				// 		// 		"userId": "string",
				// 		// 		"userName": "string"
				// 		// 	}
				// 		// },
				// 		// "invitationTime": 0,
				// 		// "invitationShop": {
				// 		// 	"shopId": "string",
				// 		// 	"shopName": "string"
				// 		// },
				// 		// "demandList": [
				// 		// 	{
				// 		// 		"categoryInfo": {
				// 		// 			"categoryId": "string",
				// 		// 			"categoryName": "string",
				// 		// 			"categoryCode": "string"
				// 		// 		},
				// 		// 		"color": "string",
				// 		// 		"petSex": "string",
				// 		// 		"ageInfo": {
				// 		// 			"ageMin": 0,
				// 		// 			"ageMax": 0,
				// 		// 			"ageStr": "string"
				// 		// 		},
				// 		// 		"applyType": "string",
				// 		// 		"vaccineNumber": 0,
				// 		// 		"budgetMin": 0,
				// 		// 		"budgetMax": 0,
				// 		// 		"demandRemark": "string"
				// 		// 	}
				// 		// ]
				// 	},
				// }
				// console.log(this.curItem,params)
				// this.$http.post(process.env.VUE_APP_Url_8020+'/api/returnvisit/insert', params).then(res => {
				// 	if (res.code == 0) {
				// 		this.$message({
				// 			message: '操作成功',
				// 			type: 'success'
				// 		});
				// 		this.$emit('submit',{type:'success'})
				// 	}
				// })
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:220px;
				display: block;
				margin:150px auto 80px;
			}
			.row{
				padding:20px 20px 0;float: none;font-size: 20px;
				.label{
					display: inline-block;width:100px;text-align: right;font-size: 14px;color:$fontColor;
				}
				.value{
					display: inline-block;font-size: 14px;color:$fontColor;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
